import subjectInfoPopupComponent from './subjectInfoPopup.component';

const subjectInfoPopupModule = angular.module('app.components.clinicalData.subjects.subjectInfoPopup', [])
	.component('subjectInfoPopup', subjectInfoPopupComponent)
	.name;

export default subjectInfoPopupModule;
